export default {
    book: 'Rezerviši {product}',
    age_limit: 'Samo za osobe starije od {age} godina',
    change_plan: 'Promijeni plan',
    upgrade_product: 'Nadogradi proizvod',
    upgrade: 'Nadogradi',
    cancel_upgrade: 'Otkaži nadogradnju',
    choose_product: 'Izaberi {product}',
    days: '{count} dan | {count} dana',
    login_register: 'Prijava/Registracija',
    current: 'Trenutno',
    keyless_benefits: {
        label: 'Direktno do auta {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Puno osiguranje',
            zero_excess: 'Bez dodatnih troškova',
            phone_as_a_key: 'Telefon kao ključ',
            straight_to_car: 'Bez čekanja',
            no_queues: 'Bez redova',
            online_id_check: 'Online provjera identiteta',
            self_checkout: 'Samostalna prijava',
        },
    },
};
